// Původní název:		invia.widgets.AjaxForm
// Původní umístění:	shared/js/static/widget/invia.widgets.AjaxForm.js
// #CHECKED jthiemel 190102


import $ from 'jquery';
import 'jquery-form';
import AjaxResponse from '@invia/web-library/helpers/ajaxResponse';
import PopupWindow from './popupWindow';
import { createMessage } from './userMessages';
import { initAntiSpamControl } from '../components/antiSpamControl';
import { captureAjaxError } from '@invia/web-library/helpers/console';


class AjaxForm {
	constructor($formElem, options) {
		this.$formElem = $formElem;

		options = options || {};

		options = $.extend({
			requestData: null,
			onSubmit: null,
			beforeSerialize: null,
			onSendSuccess: null,
			onSendError: null,
			onSendComplete: null,
			resetForm: true,

			/**
			 * Na kterej element se ma aplikovat loader. Defaultne se prekryje jen form, ale nekdy muzu chtit prekryt vetsi
			 * prostor (napr. nejaky parent element).
			 */
			loaderWrapperElem: null,

			target: null,
			replaceTarget: true,
		}, options);

		this.requestData = options.requestData;

		this.onSubmit = options.onSubmit;
		this.beforeSerialize = options.beforeSerialize;
		this.onSendSuccess = options.onSendSuccess;
		this.onSendError = options.onSendError;
		this.onSendComplete = options.onSendComplete;
		this.resetForm = options.resetForm;

		this.$loaderWrapperElem = options.loaderWrapperElem ? $(options.loaderWrapperElem) : null;

		this.$target = options.target ? $(options.target) : null;
		this.replaceTarget = options.replaceTarget;

		this.popup = null;

		this.init();
		return this;
	}

	init() {
		var that = this;

		that.$formElem.ajaxForm({
			dataType: 'json',
			data: that.requestData,
			beforeSubmit: function (arr, $form, options) {
				that.showLoader();

				if (typeof $.fn.selectBox == 'function') {
					$form.find('select').selectBox('destroy');
				}

				that.handleOnSubmit(arr, $form, options);
				return true;
			},
			success: function (data) {
				var resp = new AjaxResponse(data);

				if (!resp.redirectUrl) {  // pri presmerovavani nema smysl resit nahrazeni formu, user messages apod.
					that.hideLoader();

					if (resp.html) {
						// dostali jsme HTML, nahradime obsah targetu/lcely target
						var $targetElement = that.getTargetElement();

						if (that.replaceTarget) {
							var $newContent = $(resp.html);
							$targetElement.replaceWith($newContent);

							that.$target = $newContent;
							that.$formElem = null;
						} else {
							if ($.contains($targetElement.get(0), that.$formElem.get(0))) {
								that.$formElem = null;  // uz nebude vic existovat, nahradim ho
							}

							$targetElement.html(resp.html);
						}

						// puvodni form uz neexistuje, musime ho inicializovat znovu
						if (!that.$formElem) {
							var $newFormElem = that.$target.is('form') ? that.$target : that.$target.find('form');
							that.$formElem = $newFormElem;
							that.init();
						}

						if (typeof $.fn.selectBox == 'function') {
							that.$formElem.find('select').selectBox();
						}

						if (that.$formElem.data('antispam') == 1) {
							initAntiSpamControl(that.$formElem);
						}
					} else {
						that.handleFormErrorMessages(resp.formErrorMessages);

						if (resp.responseIsOk && that.resetForm) {
							that.$formElem.resetForm();
						}
					}

					if (resp.userMessages) {
						// na mobilu mozno predelat na zobrazeni pres invia.showFixedMessage (zobrazi UM na spodnim okraji obrazovky)
						var msgHtml = '';

						$.each(resp.userMessages, function () {
							msgHtml += createMessage(this.type, this.text);
						});

						that.getTargetElement().prepend(msgHtml);
					}
				}

				if (resp.responseIsOk) {
					that.handleOnSendSuccess(resp);
				} else {
					that.handleOnSendError(resp);
				}

				that.handleOnSendComplete(resp);

				if (resp.redirectUrl) {
					window.location = resp.redirectUrl;
					return;
				}
			},
			beforeSerialize: function ($form, options) {
				if (typeof that.beforeSerialize == 'function') {
					return that.beforeSerialize.call(this, $form, options);
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				captureAjaxError(jqXHR, textStatus, errorThrown, this);
				that.hideLoader();
			},
		});
	}

	getLoaderWrapperElement() {
		return this.$loaderWrapperElem ? this.$loaderWrapperElem : this.getTargetElement();
	}

	getTargetElement() {
		return this.$target ? this.$target : this.$formElem;
	}

	showLoader() {
		if (this.popup) {
			this.popup.showLoader();
		} else {
			var $wrapper = this.getLoaderWrapperElement();

			$wrapper.addClass('ajaxLoaderWrap');
			$wrapper.append('<div class="ajaxLoader semitransparent"></div>');
		}
	}

	hideLoader() {
		if (this.popup) {
			this.popup.hideLoader();
		} else {
			var $wrapper = this.getLoaderWrapperElement();

			$wrapper.removeClass('ajaxLoaderWrap');
			$wrapper.find('> .ajaxLoader').remove();
		}
	}

	handleFormErrorMessages(errorMessages) {
		this.$formElem.find('ul.int-info').remove();
		this.$formElem.find('.invia-form-element.int-error').removeClass('int-error');

		if (typeof errorMessages != 'object') {
			return;
		}

		$.each(errorMessages, function (elemName, errors) {
			var listItems = '';

			$.each(errors, function (j, msg) {
				listItems += '<li>' + msg + '</li>';
			});

			var list = '<ul class="reset int-info">' + listItems + '</ul>';

			$('[name="' + elemName + '"]').closest('.invia-form-element')
				.append(list)
				.addClass('int-error');
		});
	}

	handleOnSubmit(arr, $form, options) {
		if (typeof this.onSubmit == 'function') {
			this.onSubmit.call(this, arr, $form, options);
		}
	}

	handleOnSendSuccess(response) {
		if (typeof this.onSendSuccess == 'function') {
			this.onSendSuccess.call(this, response);
		}
	}

	handleOnSendError(response) {
		if (typeof this.onSendError == 'function') {
			this.onSendError.call(this, response);
		}
	}

	handleOnSendComplete(response) {
		if (typeof this.onSendComplete == 'function') {
			this.onSendComplete.call(this, response);
		}
	}

	setPopup(popup) {
		if (!(popup instanceof PopupWindow)) {
			throw new Error('Popup has to be instance of PopupWindow');
		}

		this.popup = popup;
	}
}

export default AjaxForm;
